"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var LinkableButtonController = /** @class */ (function (_super) {
    __extends(LinkableButtonController, _super);
    function LinkableButtonController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            (0, jquery_1.default)(_this.element).on('click', function (event) {
                event.preventDefault();
                var trackEvent = (_this.data.get('analyticsTrackEvent') || '').split(' ');
                if (trackEvent.every(Boolean) && trackEvent.length >= 3) {
                    google_analytics_manager_1.default.postGAEvent(trackEvent[0], trackEvent[1], trackEvent[2]);
                }
                location.href = _this.data.get('href') || '#';
            });
        };
        return _this;
    }
    return LinkableButtonController;
}(stimulus_1.Controller));
exports.default = LinkableButtonController;
